module.exports = __webpack_public_path__ + "img/none_icon.a653806c.png";